import { ChangeDetectionStrategy, Component, forwardRef, input, ViewChild } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { LandmarkCategory, Unit } from '../../database/models';
import { TreeComponent } from '../tree/tree.component';

import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';

type EntityItem = Unit | LandmarkCategory;

@Component({
  selector: 'tree-select',

  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatChipsModule,
    MatIconModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatMenuModule,
    TreeComponent,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TreeSelectComponent),
      multi: true,
    },
  ],
  templateUrl: './tree-select.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './tree-select.component.scss',
})
export class TreeSelectComponent implements ControlValueAccessor {
  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

  public label = input<string>();
  public placeholder = input<string>();
  public searchPlaceholder = input<string>();
  public entityType = input<'category' | 'service'>();

  public control = new FormControl<(Unit | LandmarkCategory)[]>([]);

  public selectedItems = [];

  public MAX_DISPLAY_CHIPS = 3;

  private onChange: (value: EntityItem[]) => void = () => {};
  private onTouched: () => void = () => {};

  public onSelectTreeItem(items: EntityItem[]) {
    setTimeout(() => this.trigger.updatePosition(), 200); // follow trigger input when it move causing by filter.
    this.control.setValue([...items]);
    this.onChange(items);
  }

  public remove(value: EntityItem) {
    const updatedValue = this.control.value?.filter(item => item !== value) || [];
    this.control.setValue(updatedValue);
  }

  // ControlValueAccessor methods
  writeValue(value: EntityItem[]): void {
    if (value) {
      this.selectedItems = value.map(({ uid }) => uid);
      this.control.setValue(value, { emitEvent: false });
    } else {
      this.selectedItems = [];
      this.control.setValue([], { emitEvent: false });
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public closeMenu() {
    this.trigger.closeMenu();
  }
}
